import type { Comment } from '../../entities/comment/commentTypes';
import { MOCK_GROUP_ID } from './mockSite';

/**
 * Dataset mock per Comment (entità polimorfica). Ogni record punta a un
 * record realmente esistente negli altri mock via `className` (FQN Java) +
 * `classPK`:
 *   - Person  -> personId 1, 3        (personMocks: 1-18)
 *   - Business -> businessId 1, 2      (businessMocks: 1-12)
 *   - Task    -> taskId 2, 4           (taskMocks: NON parte da 1)
 *   - Note    -> noteId 1              (noteMocks: 1-10)
 *   - Call    -> callId 1              (callMocks: 1-10)
 *   - Meeting -> meetingId 1           (meetingMocks: 1-10)
 *
 * userId/userName matchano MOCK_USERS (mockHandlers) per il lookup avatar.
 */
const FQN = {
  person: 'it.dvel.crm.core.model.Person',
  business: 'it.dvel.crm.core.model.Business',
  task: 'it.dvel.crm.core.model.Task',
  note: 'it.dvel.crm.core.model.Note',
  call: 'it.dvel.crm.core.model.Call',
  meeting: 'it.dvel.crm.core.model.Meeting',
} as const;

const base = { companyId: 1, groupId: MOCK_GROUP_ID };
const at = (userId: number, userName: string, iso: string) => ({
  ...base,
  userId,
  userName,
  createDate: iso,
  modifiedDate: iso,
});

export const mockComments: Comment[] = [
  { commentId: 1, className: FQN.person, classPK: 1, body: 'Cliente storico, molto reattivo. Preferisce essere contattato via email.', ...at(1, 'Jader Francia', '2026-03-11T09:00:00Z') },
  { commentId: 2, className: FQN.person, classPK: 3, body: 'Da ricontattare dopo la fiera per chiarire i dettagli sul nuovo ordine.', ...at(2, 'Michele Placido', '2026-04-04T15:30:00Z') },
  { commentId: 3, className: FQN.business, classPK: 1, body: 'Azienda in espansione: valutare upselling sul modulo reportistica.', ...at(1, 'Jader Francia', '2026-03-20T11:15:00Z') },
  { commentId: 4, className: FQN.business, classPK: 2, body: 'Referente tecnico molto preparato, interlocuzione rapida e diretta.', ...at(3, 'Marco Zanetti', '2026-04-09T08:45:00Z') },
  { commentId: 5, className: FQN.task, classPK: 2, body: 'Bloccato in attesa di risposta dal cliente.', ...at(1, 'Jader Francia', '2026-03-28T10:00:00Z') },
  { commentId: 6, className: FQN.task, classPK: 4, body: 'Priorità alzata: scadenza anticipata a fine settimana.', ...at(2, 'Michele Placido', '2026-04-02T16:20:00Z') },
  { commentId: 7, className: FQN.note, classPK: 1, body: 'Aggiornata con le ultime condizioni commerciali concordate.', ...at(1, 'Jader Francia', '2026-03-15T12:00:00Z') },
  { commentId: 8, className: FQN.call, classPK: 1, body: 'Esito positivo: fissato il secondo incontro tecnico entro fine aprile.', ...at(1, 'Jader Francia', '2026-04-10T09:40:00Z') },
  { commentId: 9, className: FQN.meeting, classPK: 1, body: 'Verbale condiviso con il team. Prossimi step assegnati ai referenti.', ...at(4, 'Francesca Ruocco', '2026-04-15T11:30:00Z') },
];
